import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from '@angular/cdk/dialog';
import { BrowserDialogContentComponent } from './internal/browser-dialog-content.component';

@NgModule({
  imports: [CommonModule, DialogModule, BrowserDialogContentComponent]
})
export class BrowserDialogModule {}
